// extracted by mini-css-extract-plugin
module.exports = {"root":"article-page_root__7pxJw"};